// Module
var code = `<h2 class="section-header">Batch memo history</h2>

<table ng-table="\$ctrl.tableConfig" class="table">
  <thead>
  <tr>
    <th>No</th>
    <th>Uploaded on</th>
    <th>Uploaded by</th>
    <th>Filename</th>
    <th>Remarks</th>
    <th>Type</th>
    <th>Successful count</th>
    <th>Failed count</th>
    <th>Total count</th>
    <th></th>
  </tr>
  </thead>
  <tr ng-repeat="history in \$data">
    <td>{{\$index + 1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}</td>
    <td>{{history.registrationTime | prettyDateTime}}</td>
    <td>{{history.executedByUsername}}</td>
    <td>{{history.filename ? history.filename : '-'}}</td>
    <td>{{history.remarks}}</td>
    <td>{{history.entryType | prettyEnum}}</td>
    <td>{{history.successfulCount}}</td>
    <td>{{history.failedCount}}</td>
    <td>{{history.successfulCount + history.failedCount}}</td>
    <td class="table__actions">
      <button type="button" class="btn btn-success" ng-click="\$ctrl.downloadSummaryReport('AccountBatchMemoConfirmationReport', 'BatchMemoSummary.xlsx', history.commandId)">Success Report</button>
      <button type="button" class="btn btn-warning" ng-click="\$ctrl.downloadSummaryReport('AccountBatchMemoFailedSummaryReport', 'FailedBatchMemoSummary.xlsx', history.commandId)">Failed Report</button>
    </td>
  </tr>
</table>

<div ng-if="!\$ctrl.totalRowCount" class="empty-message">
  <span>No batch memo history found</span>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/memo/history/batch-memo-history.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;